/* eslint-disable eol-last */
import { makeStyles } from '@eagleview/ev-comp-library';

export default makeStyles((theme) => ({
  subContainer: {
    padding: `2px ${theme.spacing(2)}px`,
    border: `2px solid ${theme.evPalette.charcoal[200]}`,
  },
  subContainerHighlighted: {
    padding: `2px ${theme.spacing(2)}px`,
    border: `2px solid ${theme.evPalette.ocean[600]}`,
  },
  divider: {
    backgroundColor: theme.evPalette.charcoal[200],
  },
  heightBar: {
    minHeight: '48px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  flexEnd: {
    justifyContent: 'flex-end',
  },
  remainingSpace: {
    flex: 1,
  },
  annomalyTypeText: {
    color: theme.evPalette.charcoal[900],
    fontWeight: theme.typography.fontWeightBold,
  },
  iconButtons: {
    minWidth: '20px',
    padding: theme.spacing(1),
    margin: 0,
  },
  anomalyNotesButtonSelected: {
    backgroundColor: theme.evPalette.charcoal[100],
  },
  anomalyNotesButtonHighlighted: {
    color: theme.evPalette.ocean[600],
  },
  typeBar: {
    minHeight: '48px',
    display: 'flex',
    alignItems: 'center',
    marginBottom: '8px',
  },
  typeTitle: {
    fontSize: theme.typography.pxToRem(12),
    fontWeight: '600',
    color: theme.evPalette.charcoal[900],
    lineHeight: theme.typography.pxToRem(12),
    marginRight: '8px',
  },
  selectBar: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  select: {
    width: '170px',
    color: theme.palette.common.black,
  },
  selectBarItem: {
    color: theme.palette.common.black,
  },
  buttonConfirm: {
    textTransform: 'none',
    marginLeft: '10px',
  },
  buttonRemove: {
    textTransform: 'none',
    marginLeft: '10px',
    color: theme.evPalette.ocean[600],
  },
  markDamage: {
    position: 'relative',
    right: theme.spacing(2.25),
  },
  expansionButton: {
    position: 'absolute',
    top: 0,
    right: 0,

  },
  expansionIcon: {
    color: theme.palette.common.white,
    fontSize: 40,
  },
  anomalyMapContainer: {
    position: 'relative',
    height: '164px',
    width: '256px',
    borderRadius: '4px',
    overflow: 'hidden',
    marginBottom: '16px',
    backgroundColor: theme.palette.common.black,
  },
  anomalyMapContainerEmptyState: {
    position: 'relative',
    height: '0',
  },
  anomalyImage: {
    height: '100%',
    width: '100%',
  },
}));